<template>
	<vue-tel-input class="form-control" :autofocus="false" mode="international" placeholder="Ingresar número teléfono" v-bind="$attrs" v-model="telefono" @input="onInput" :defaultCountry="defaultCountry"></vue-tel-input>
</template>
<script>
	export default {
		props: ['value'],
		
		data(){
			return {
				error: ''
			}
		},

		computed: {
		    telefono: {
		    	get: function(){
		    		return this.value
		    	},

		    	set: function(val){
		    		this.$emit('input', val)
		    	}
			},
			configuracion(){
				return this.configuracionBase() || {}
			},
			pais(){
				return this.configuracion.pais || {}
			},
			defaultCountry(){
				return this.pais.ABREVIATURA || 'GT'
			}
		},

		methods: {
			onInput: function(formattedNumber, {number, isValid, country}){
				this.$emit('inputValues', {number, isValid, country})
			}
		}
	}
</script>
<style scoped>
	.vue-tel-input:focus-within, .vue-tel-input:focus {
		border-color: #f18b8f !important;
		box-shadow: none !important;
	}
</style>